import React, { Component } from 'react';
import _AdminService from 'modules/AdminService';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import _notification from 'modules/notification';
import { Modal } from 'antd';
import ConfirmPopup from '../popup/ConfirmPopup';
import { GENERAL_ERROR_MESSAGE } from '../../constants/constants';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import Button from 'components/controls/Button';


class SendBulkHallTicketEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showConfirmPopup: false
        };
    }

    handleConfirmPopup = () => {
        this.setState({
            showConfirmPopup: true
        })
    }

    closeMessageBox(value = false) {
        this.setState({ showConfirmPopup: value });
    }

    //Message box confirm delete click
    onConfirmDelete = async () => {
        this.setState({ loading: true }, async () => {

            try {
                const response = await _AdminService.SendBulkHallTicketEmail();

                const data = response.data;
                if (data.IsSuccess == true) {
                    _notification.showMessage('success', "Email will send");
                    this.setState({
                        loading: false,
                        showConfirmPopup: false
                    });
                }
                else {
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                    this.setState({
                        loading: false,
                        showConfirmPopup: false
                    });
                }
            } catch (error) {
                this.setState({
                    loading: false,
                    showConfirmPopup: false
                });
                console.log('Error: ', error);
                _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
            }
        });
    }

    render() {
        if (this.state.loading)
            return <LoadingSpinner/>

        return (
            <div className="container  analysisWrap pt-3 pb-3 p-sm-4 p-md-2">
                <PageHeader
                    title="Send Bulk Hall Ticket Email"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Communications' }, { label: 'Send Bulk Hall Ticket Email' }]}
                />
                <div className="max1200 m-auto">
                    <div className="ent-panel">
                        <div className="mb-2 col-sm-12  pb-3">
                            <h5 className="color-secondary">Click on Send button to send bulk hall ticket Email</h5>
                        </div>
                        <div className="mb-2 mt-6 col-sm-12 buttonAlignCenter" >
                            <Button type="button" value="Send" onClick={this.handleConfirmPopup} className="button-global button-primary" />
                        </div>
                    </div>
                </div>


                <Modal
                    centered={true}
                    width={500}
                    className="modelPopAnt"
                    visible={this.state.showConfirmPopup}
                    onCancel={() => this.closeMessageBox(false)}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.closeMessageBox(false)}
                        onOk={this.onConfirmDelete}
                        message="Are you sure, you want to send bulk hall ticket Email?"
                    />
                </Modal>

            </div>
        )

    }
}

export default SendBulkHallTicketEmail;